import { Button } from 'components/atoms'
import AvatarImage from 'components/atoms/AvatarImage'
import RoleLabel from 'components/atoms/RoleLabel'
import TextWrap from 'components/atoms/TextWrap'
import I18n from 'core/i18n'
import * as React from 'react'
import { BREAKPOINT_TABLET_LARGE, COLORS } from 'static/constants'
import { IUser } from 'static/interfaces'
import styled from 'styled-components'

interface IProps {
  user: IUser
  agentMember?: { name: string; email: string }
}
const DashboardProfile: React.VFC<IProps> = ({ user, agentMember }) => {
  const editProfile = () => {
    location.href = `/settings/profile`
  }
  return (
    <Profile user={user}>
      <div className="profile_main">
        <div className="profile_avatar">
          <AvatarImage avatarURL={user.avatar_middle_url} />
        </div>
        <div>
          <div className="profile_info">
            {agentMember ? (
              <>
                <p className="info_name">{agentMember.name}</p>
                <p className="info_email">{agentMember.email}</p>
                <div className="info_parent_agent">
                  <span className="parentLabel">{I18n.t('generic.agent')}:</span> {user.username}
                </div>
              </>
            ) : (
              <p className="info_name">{user.username}</p>
            )}
            <div className="info_role">
              <RoleLabel user={user} />
              {agentMember && <span className="memberLabel">Member</span>}
            </div>
          </div>
          {!agentMember && (
            <div className="profile_buttons">
              <Button small={true} rounded={true} link={true} handleClick={editProfile}>
                {I18n.t('settings.edit_profile')}
              </Button>
            </div>
          )}
        </div>
      </div>
      <div className="profile_bio">
        <TextWrap text={user.bio} noMargin={true} />
      </div>
    </Profile>
  )
}

const Profile = styled.div`
  display: flex;
  padding-bottom: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${COLORS.divider};
  @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
    flex-wrap: wrap;
  }
  .profile_main {
    display: flex;
    width: 55%;
    @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
      flex-wrap: wrap;
      width: 100%;
    }
  }
  .profile_avatar {
    flex-shrink: 0;
    width: 112px;
    height: 112px;
    margin-right: 20px;
    @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
      width: 56px;
      height: 56px;
    }
  }
  .profile_info {
    min-height: 56px;
    @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
      width: 100%;
    }
    .info_name {
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 18px;
      font-weight: 700;
    }
    .info_email {
      font-size: 12px;
      color: ${COLORS.subText};
      margin-top: 2px;
    }
    .info_parent_agent {
      font-size: 12px;
      color: ${COLORS.subText};
      margin-top: 4px;
      .parentLabel {
        font-weight: 600;
      }
    }
    .info_role {
      display: flex;
      align-items: center;
      gap: 8px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 4px;

      .hostName {
        font-size: 12px;
      }
      .memberLabel {
        font-size: 11px;
        color: ${COLORS.white};
        background-color: ${COLORS.primary};
        padding: 2px 8px;
        border-radius: 4px;
      }
    }
  }
  .profile_buttons {
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 24px auto 4px;
    @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
      display: none;
    }
  }
  .profile_bio {
    width: 45%;
    padding-left: 52px;
    font-size: 14px;
    @media (max-width: ${BREAKPOINT_TABLET_LARGE}px) {
      width: 100%;
      padding-left: 0;
    }
  }
`

export default DashboardProfile
